import { buildTimestampAccessor, getDateFormatter } from '../../features/metricValue';
import { buildFirstThresholdTimestampAccessor } from '../../features/threshold';
import { Messages } from '../../localization';
import { DataRow, EffectiveDefinition } from '../../models';
import { RowSubtitleFunction } from './RowSubtitleFunction';

export const historicalComparisonRowSubtitle = (definition: EffectiveDefinition): RowSubtitleFunction => {
  return (currentPoint: DataRow) => {
    const timestampAccessor = buildTimestampAccessor(definition);
    const comparisonTimestampAccessor = buildFirstThresholdTimestampAccessor(definition);
    const dateFormatter = getDateFormatter(definition);

    const currentPointDate = timestampAccessor(currentPoint);
    const comparisonDate = comparisonTimestampAccessor && comparisonTimestampAccessor(currentPoint);

    if (!currentPointDate || !comparisonDate) {
      return Messages.metricsNoComparisonRowSubtitle();
    }

    return dateFormatter.comparisonWidget(currentPointDate, comparisonDate);
  };
};
